import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { fragmentsPermissions } from '@mi-front/api-clients';
import { Station } from '@mi-front/core';
import { PlatformUploadFields } from './PlatformUploadFields';

type Props = {
  station: Station;
};

/**
 * @deprecated Only used in the fragment create dialog
 */
export function FragmentSocialExportFields({ station }: Props) {
  return (
    <IfPermission permission={fragmentsPermissions.Fragments_SocialPublish}>
      <div>
        {socialPlatforms.all().map((platform) => (
          <PlatformUploadFields key={platform.id} stationId={station.id} platform={platform} />
        ))}
      </div>
    </IfPermission>
  );
}
